export const cmsHost = __CMS__ || (window.location.protocol + '//' + window.location.host);
export const langHosts = __LANG_HOSTS__;
